import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentConfig {
    constructor() {}

    getApiUrl() {
        return environment.apiUrl;
    }
}
